<template>
  <div class="new-file-item" @click="previewFile">
    <div class="file-icon">
      <file-thumb-icon
          :type="file.type"
          :name="file.name"
          :thumbnail="file.thumbnail"
          :typeIcon="file.type_icon"
        />
    </div>
    <div class="file-info ellipsis">
      <div class="file-name ellipsis">{{ file.name }}</div>
      <div class="file-size" v-if="file.created_at || file.size">{{file.created_at && createTime(file.created_at)}} {{ file.size && getSize(file.size) }}</div>
    </div>
  </div>
</template>
<script>
import {i18n} from '@/utils/i18n'
import {formatDate, approxSize} from '@/utils/common'
import FileThumbIcon from './FileThumbIcon.vue'

export default {
  name: 'NewFileItem',
  i18n,
  components: {
    FileThumbIcon
  },
  props: {
    file: {
      type: Object
    },
    extraParams: {
      type: Object
    },
    preview: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {}
  },
  watch: {},
  created () {},
  methods: {
    previewFile () {
      if (!this.$props.preview) return
      const param = {
        id: this.$props.file.id || this.$props.file.fileId,
        name: this.$props.file.name
      }
      let message = {
        method: 'preview',
        params: param
      }
      if (this.$props.extraParams) {
        const { scenario, workflowNo, templateId } = this.$props.extraParams
        message.action = scenario
        if (scenario === 'workflow') {
          message.params.workflowNo = workflowNo
          message.params.templateId = templateId
        }
      }
      console.log(message, this.$props.extraParams, this.$router)
      // eslint-disable-next-line no-undef
      fangcloud.postMessage(JSON.stringify(message))
    },
    getSize (size) {
      return approxSize(size)
    },
    createTime (time) {
      return formatDate(time * 1000, '%YY-%MM-%DD')
    }
  }
}
</script>
<style lang="postcss">
@import 'variables';
.new-file-item {
  display: flex;
  padding: 12px 0;
  flex: 1 1 auto;
  width: 100%;
  & .file-icon {
    display: flex;
    width: 30px;
    align-items: center;
    margin-right: 16px;

    & img {
      width: 30px;
      height: 30px;
    }
  }
  & .file-info {
    display: flex;
    flex-direction: column;
    width: 100%;
    box-sizing: border-box;
    & .file-name {
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      margin-bottom: 2px;
      color: var(--fontBasicColor);
      display: block;
    }

    & .file-size {
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
      color: #626F84;
    }
  }
}

</style>
